// FAQ accordion. Root element: [data-sw-faq] (one per section).
//   data-pin-height  present when the section height must be pinned on mobile
(function () {
  if (window.__swFaqLoaded) return;
  window.__swFaqLoaded = true;

  var SELECTOR = '[data-sw-faq]';
  var instances = [];

  function init(section) {
    if (section.dataset.swInit) return; // guard against double init
    section.dataset.swInit = '1';

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cleanups = [];
    var timers = [];
    var ctx = gsap.context(function () {}, section);

    // ── Accordion ──
    section.querySelectorAll('.sw-faq__item').forEach(function (item) {
      var summary = item.querySelector('.sw-faq__question');
      var inner   = item.querySelector('.sw-faq__answer-inner');

      // Reduced motion: toggle open/closed instantly, no height tweens
      if (reduceMotion) {
        summary.addEventListener('click', function (e) {
          e.preventDefault();
          if (item.open) {
            item.removeAttribute('open');
          } else {
            section.querySelectorAll('.sw-faq__item[open]').forEach(function (openItem) {
              openItem.removeAttribute('open');
            });
            item.setAttribute('open', '');
          }
        });
        return;
      }

      ctx.add(function () {
        gsap.set(inner, { height: item.open ? 'auto' : 0 });
      });

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        // Tweens run inside the context so they are reverted on section unload
        ctx.add(function () {
          if (item.open) {
            gsap.to(inner, {
              height: 0, duration: 0.3, ease: 'power2.inOut', overwrite: true,
              onComplete: function () { item.removeAttribute('open'); }
            });
          } else {
            section.querySelectorAll('.sw-faq__item[open]').forEach(function (openItem) {
              var openInner = openItem.querySelector('.sw-faq__answer-inner');
              gsap.to(openInner, {
                height: 0, duration: 0.3, ease: 'power2.inOut', overwrite: true,
                onComplete: function () { openItem.removeAttribute('open'); }
              });
            });
            item.setAttribute('open', '');
            gsap.to(inner, { height: 'auto', duration: 0.35, ease: 'power2.inOut', overwrite: true });
          }
        });
      });
    });

    if (section.hasAttribute('data-pin-height')) {
      // On mobile: pin the section to the largest possible state — all questions
      // collapsed plus the tallest single answer. Since only one opens at a time,
      // this is the exact maximum height needed. Prevents bg image zoom on expand.
      var pinMobileHeight = function () {
        // SW: 750px and wider (for example a phone rotated to landscape) the CSS height applies again
        if (window.innerWidth >= 750) { section.style.removeProperty('height'); section.style.removeProperty('min-height'); return; }
        var savedOverflow  = section.style.overflow;
        section.style.height    = 'auto';
        section.style.minHeight = '0';
        section.style.overflow  = 'visible';
        var collapsedH = section.scrollHeight;
        var maxAnswerH = 0;
        section.querySelectorAll('.sw-faq__answer-inner').forEach(function (inner) {
          maxAnswerH = Math.max(maxAnswerH, inner.scrollHeight);
        });
        section.style.height    = Math.ceil(collapsedH + maxAnswerH) + 'px';
        section.style.minHeight = 'unset';
        section.style.overflow  = savedOverflow;
      };
      pinMobileHeight();
      // SW: re-pin as soon as the viewport width changes (rotation); height-only changes (browser bars) are ignored
      var lastW = window.innerWidth;
      var onResize = function () {
        if (window.innerWidth === lastW) return;
        lastW = window.innerWidth;
        pinMobileHeight();
      };
      window.addEventListener('resize', onResize, { passive: true });
      window.addEventListener('orientationchange', onResize);
      cleanups.push(function () {
        window.removeEventListener('resize', onResize);
        window.removeEventListener('orientationchange', onResize);
      });
    }

    instances.push({
      el: section,
      destroy: function () {
        ctx.revert();
        timers.forEach(clearTimeout);
        cleanups.forEach(function (fn) { fn(); });
      }
    });
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(init);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var roots = e.target.querySelectorAll(SELECTOR);
    if (!roots.length) return;
    swGsap.load(function () { roots.forEach(init); }, { scrollTrigger: true });
  });

  document.addEventListener('shopify:section:unload', function (e) {
    instances = instances.filter(function (inst) {
      if (e.target.contains(inst.el)) { inst.destroy(); return false; }
      return true;
    });
  });

  swGsap.load(initAll, { scrollTrigger: true });
})();
